// @flow
import React from 'react'
import { connect } from 'react-redux'
import { openRebateTermsModal } from '../../actions/modals'
import LinkButton from '../../components/LinkButton'

type Props = {
  rebate: number,
  openRebateTermsModal: Function
}

const RebateButton = (
  { rebate, openRebateTermsModal }: Props // eslint-disable-line no-shadow
) => (
  <LinkButton
    color="success"
    onClick={openRebateTermsModal}
    style={{ textDecoration: 'none' }}
  >
    {`$${rebate}*`}
  </LinkButton>
)

export default connect(
  null,
  { openRebateTermsModal }
)(RebateButton)



// WEBPACK FOOTER //
// ./src/components/RebateButton/index.js